/**
 * @generated SignedSource<<5ce8fdbc9f6f24e4a99509928b32387e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type editFlexLicenseDefinitionButton_LicenseDefinitionFragment$data = {
  readonly data: {
    readonly excludedNodeIds?: ReadonlyArray<{
      readonly rootId: string;
      readonly title: string;
    }>;
    readonly includedNodeIds?: ReadonlyArray<{
      readonly rootId: string;
      readonly title: string;
    }>;
    readonly name?: string;
  };
  readonly id: string;
  readonly " $fragmentType": "editFlexLicenseDefinitionButton_LicenseDefinitionFragment";
};
export type editFlexLicenseDefinitionButton_LicenseDefinitionFragment$key = {
  readonly " $data"?: editFlexLicenseDefinitionButton_LicenseDefinitionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"editFlexLicenseDefinitionButton_LicenseDefinitionFragment">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "rootId",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "title",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "editFlexLicenseDefinitionButton_LicenseDefinitionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "data",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LicenseDefinitionRootInfo",
              "kind": "LinkedField",
              "name": "includedNodeIds",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "LicenseDefinitionRootInfo",
              "kind": "LinkedField",
              "name": "excludedNodeIds",
              "plural": true,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "type": "FlexLicenseDefinitionData",
          "abstractKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LicenseDefinition",
  "abstractKey": null
};
})();

(node as any).hash = "c598924f5343e4bbb8cb757d93fd3bd6";

export default node;
